<template>
  <div id="ns-asko">
    <loading-block v-if="initLoad"/>
    <transition name="slide" mode="out-in" v-else>
      <component :is="store.currentRoute" v-bind="store"/>
    </transition>
  </div>
</template>

<script>
import Step1 from '@/components/Step1';
import Step2 from '@/components/Step2';
import Step3 from '@/components/Step3';
import Step4 from '@/components/Step4';
import LoadingBlock from '@/components/misc/LoadingBlock.vue';
import {access} from './config';

export default {
  name: 'NsAcko',
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    LoadingBlock,
  },
  data() {
    return {
      access,
      mock: false,
      store: {
        dictionaries: {
          issuanceSumms: [],
          issuancePeriods: [],
          sportTypes: [],
          issuanceTypes: [],
        },
        requestModel: {
          firstForm: {
            period: '',
            sum: '',
            sportType: '',
            actionPeriod: '',
            countChildren: 0,
            countAdult: 0,
          },
          secondForm: {
            issuanceType: '',
            lastName: '',
            firstName: '',
            middleName: '',
            birthDay: '',
            documentType: '',
            passportSerial: '',
            passportNumber: '',
            passportIssDate: '',
            phoneNumber: '',
            email: '',
          },
          thirdForm: {
            insured: [],
          },
        },
        externalData: null,
        currentRoute: null,
      },
      mapApiAttributes: [
        {
          attrIsn: '949111',
          dictionary: 'issuanceSumms',
        },
        {
          attrIsn: '949031',
          dictionary: 'issuancePeriods',
        },
        {
          attrIsn: '949041',
          dictionary: 'issuanceTypes',
        },
        {
          attrIsn: '1055131',
          dictionary: 'sportTypes',
        },
      ],
      comps: {
        step1: () => Step1,
        step2: () => Step2,
        step3: () => Step3,
        step4: () => Step4,
      },
      agreement: null,
      email: '',
      issuer: {
        lastName: '',
        firstName: '',
        middleName: '',
        birthday: '',
      },
      initLoad: true,
      dateBeginAgreement: null,
      token: '',
      peopleCount: 0,
    };
  },
  methods: {
    init() {
      if (!this.mock) {
        this.initLoad = true;
        this.$api.initialize(this.token)
            .then((data) => {
              console.log(data);
              this.store.externalData = data;
              this.store.currentRoute = 'step1';
              this.store.externalData.params.forEach((el) => {
                this.mapApiAttributes.forEach((attr) => {
                  if (attr.attrIsn === el.attrIsn) {
                    this.store.dictionaries[attr.dictionary] = el.values;
                  }
                });
              });
              this.initLoad = false;
            });
      } else {
        // start mock
        this.initLoad = false;
        const data = {
          'isn': '1530880',
          'productName': 'Спортивная защита',
          'params': [
            {
              'isn': '261604814',
              'attrIsn': '949031',
              'fullName': 'Период страхования',
              'val': '949961',
              'value': '12 МЕСЯЦЕВ',
              'values': [
                {
                  'isn': '949851',
                  'value': '1 МЕСЯЦ',
                },
                {
                  'isn': '949861',
                  'value': '2 МЕСЯЦА',
                },
                {
                  'isn': '949871',
                  'value': '3 МЕСЯЦА',
                },
                {
                  'isn': '949881',
                  'value': '4 МЕСЯЦА',
                },
                {
                  'isn': '949891',
                  'value': '5 МЕСЯЦЕВ',
                },
                {
                  'isn': '949901',
                  'value': '6 МЕСЯЦЕВ',
                },
                {
                  'isn': '949911',
                  'value': '7 МЕСЯЦЕВ',
                },
                {
                  'isn': '949921',
                  'value': '8 МЕСЯЦЕВ',
                },
                {
                  'isn': '949931',
                  'value': '9 МЕСЯЦЕВ',
                },
                {
                  'isn': '949941',
                  'value': '10 МЕСЯЦЕВ',
                },
                {
                  'isn': '949951',
                  'value': '11 МЕСЯЦЕВ',
                },
                {
                  'isn': '949961',
                  'value': '12 МЕСЯЦЕВ',
                },
              ],
            },
            {
              'isn': '261604804',
              'attrIsn': '1055131',
              'fullName': 'Виды спорта',
              'val': '3288069',
              'value': [],
              'values': [
                {
                  'isn': '826871',
                  'value': 'Категория 0',
                },
                {
                  'isn': '851791',
                  'value': 'Авиамодельный спорт',
                },
                {
                  'isn': '973591',
                  'value': 'Автомодельный спорт',
                },
                {
                  'isn': '851821',
                  'value': 'Аква - аэробика',
                },
                {
                  'isn': '851901',
                  'value': 'Аэробика спортивная',
                },
                {
                  'isn': '851921',
                  'value': 'Бадминтон',
                },
                {
                  'isn': '851971',
                  'value': 'Бильярд',
                },
                {
                  'isn': '852081',
                  'value': 'Бочче',
                },
                {
                  'isn': '852231',
                  'value': 'Гольф',
                },
                {
                  'isn': '958981',
                  'value': 'Дартс',
                },
                {
                  'isn': '852351',
                  'value': 'Домино',
                },
                {
                  'isn': '1055311',
                  'value': 'Дрон-рейсинг',
                },
                {
                  'isn': '852371',
                  'value': 'Занятия на спортивных тренажерах',
                },
                {
                  'isn': '852391',
                  'value': 'Йога',
                },
                {
                  'isn': '852521',
                  'value': 'Компьютерный спорт',
                },
                {
                  'isn': '852591',
                  'value': 'Лото',
                },
                {
                  'isn': '826951',
                  'value': 'Не занимается спортом',
                },
                {
                  'isn': '983631',
                  'value': 'Общая физическая подготовка (ОФП)',
                },
                {
                  'isn': '981561',
                  'value': 'Судомодельный спорт',
                },
                {
                  'isn': '853221',
                  'value': 'Фитнес',
                },
                {
                  'isn': '1030581',
                  'value': 'Фитнес-аэробика',
                },
                {
                  'isn': '853261',
                  'value': 'Ходьба скандинавская',
                },
                {
                  'isn': '853301',
                  'value': 'Шахматы',
                },
                {
                  'isn': '853311',
                  'value': 'Шашки',
                },
                {
                  'isn': '826881',
                  'value': 'Категория 1',
                },
                {
                  'isn': '851931',
                  'value': 'Балет',
                },
                {
                  'isn': '987281',
                  'value': 'Батон-твирлинг',
                },
                {
                  'isn': '852071',
                  'value': 'Боулинг',
                },
                {
                  'isn': '852091',
                  'value': 'Брейк-данс',
                },
                {
                  'isn': '852251',
                  'value': 'Городошный спорт',
                },
                {
                  'isn': '960771',
                  'value': 'Зумба',
                },
                {
                  'isn': '852401',
                  'value': 'Иппотерапия',
                },
                {
                  'isn': '852461',
                  'value': 'Катание на гироскутере',
                },
                {
                  'isn': '852471',
                  'value': 'Катание на моноколесе',
                },
                {
                  'isn': '852491',
                  'value': 'Керлинг',
                },
                {
                  'isn': '852551',
                  'value': 'Корпоративный спорт',
                },
                {
                  'isn': '1043351',
                  'value': 'Лыжероллеры',
                },
                {
                  'isn': '852611',
                  'value': 'Лыжные гонки',
                },
                {
                  'isn': '1085901',
                  'value': 'Мажорет-спорт',
                },
                {
                  'isn': '852721',
                  'value': 'Перетягивание каната',
                },
                {
                  'isn': '852741',
                  'value': 'Плавание',
                },
                {
                  'isn': '852821',
                  'value': 'Радиоспорт',
                },
                {
                  'isn': '852861',
                  'value': 'Рыболовный спорт',
                },
                {
                  'isn': '1027211',
                  'value': 'Снегоступинг',
                },
                {
                  'isn': '853031',
                  'value': 'Спортивное ориентирование',
                },
                {
                  'isn': '1038891',
                  'value': 'Танцы бальные',
                },
                {
                  'isn': '984761',
                  'value': 'Танцы на шесте ( пол дэнс)',
                },
                {
                  'isn': '1086031',
                  'value': 'Танцы народные',
                },
                {
                  'isn': '853101',
                  'value': 'Танцы спортивные',
                },
                {
                  'isn': '853111',
                  'value': 'Танцы эстрадные',
                },
                {
                  'isn': '987271',
                  'value': 'Твирлинг',
                },
                {
                  'isn': '853131',
                  'value': 'Теннис настольный',
                },
                {
                  'isn': '983561',
                  'value': 'Хип-Хоп (танец)',
                },
                {
                  'isn': '985121',
                  'value': 'Хореография',
                },
                {
                  'isn': '853281',
                  'value': 'Чирлидинг',
                },
                {
                  'isn': '826891',
                  'value': 'Категория 2',
                },
                {
                  'isn': '851961',
                  'value': 'Биатлон',
                },
                {
                  'isn': '851991',
                  'value': 'Бодибилдинг',
                },
                {
                  'isn': '852131',
                  'value': 'Водное поло',
                },
                {
                  'isn': '852181',
                  'value': 'Волейбол',
                },
                {
                  'isn': '852211',
                  'value': 'Гимнастика художественная',
                },
                {
                  'isn': '982901',
                  'value': 'Гимнастика эстетическая',
                },
                {
                  'isn': '852261',
                  'value': 'Гребля (все виды)',
                },
                {
                  'isn': '852541',
                  'value': 'Конькобежный спорт',
                },
                {
                  'isn': '852731',
                  'value': 'Пионербол',
                },
                {
                  'isn': '852781',
                  'value': 'Прыжки в воду',
                },
                {
                  'isn': '852791',
                  'value': 'Прыжки на батуте',
                },
                {
                  'isn': '852911',
                  'value': 'Синхронное плавание',
                },
                {
                  'isn': '852931',
                  'value': 'Скалолазание по искусственному рельефу',
                },
                {
                  'isn': '852951',
                  'value': 'Сквош',
                },
                {
                  'isn': '1038901',
                  'value': 'Спортивная охота',
                },
                {
                  'isn': '1058391',
                  'value': 'Спортивный пилон',
                },
                {
                  'isn': '853051',
                  'value': 'Спортивный туризм',
                },
                {
                  'isn': '853121',
                  'value': 'Теннис большой',
                },
                {
                  'isn': '853141',
                  'value': 'Трекинг',
                },
                {
                  'isn': '853201',
                  'value': 'Фехтование',
                },
                {
                  'isn': '975511',
                  'value': 'Функциональное многоборье',
                },
                {
                  'isn': '984481',
                  'value': 'Шорт-трек',
                },
                {
                  'isn': '1043361',
                  'value': 'Юкигассен',
                },
                {
                  'isn': '826901',
                  'value': 'Категория 3',
                },
                {
                  'isn': '984751',
                  'value': 'Абилимпикс',
                },
                {
                  'isn': '1027981',
                  'value': 'Акватлон',
                },
                {
                  'isn': '851851',
                  'value': 'Акробатика спортивная',
                },
                {
                  'isn': '851861',
                  'value': 'Акробатический рок-н-рол',
                },
                {
                  'isn': '1085911',
                  'value': 'Алтимат фрисби',
                },
                {
                  'isn': '851941',
                  'value': 'Баскетбол',
                },
                {
                  'isn': '851951',
                  'value': 'Бейсбол',
                },
                {
                  'isn': '852111',
                  'value': 'Велоспорт',
                },
                {
                  'isn': '984491',
                  'value': 'Воркаут',
                },
                {
                  'isn': '852281',
                  'value': 'ГТО (сдача норм)',
                },
                {
                  'isn': '852191',
                  'value': 'Гандбол',
                },
                {
                  'isn': '1080121',
                  'value': 'Гимнастика командная',
                },
                {
                  'isn': '852201',
                  'value': 'Гимнастика спортивная',
                },
                {
                  'isn': '852221',
                  'value': 'Гиревой спорт',
                },
                {
                  'isn': '852361',
                  'value': 'Езда на собачьих упряжках',
                },
                {
                  'isn': '1080631',
                  'value': 'Каникросс',
                },
                {
                  'isn': '852431',
                  'value': 'Капоэйра',
                },
                {
                  'isn': '852511',
                  'value': 'Кинологический спорт',
                },
                {
                  'isn': '852531',
                  'value': 'Конный спорт',
                },
                {
                  'isn': '852561',
                  'value': 'Кроссфит',
                },
                {
                  'isn': '987291',
                  'value': 'Лапта',
                },
                {
                  'isn': '852581',
                  'value': 'Легкая атлетика',
                },
                {
                  'isn': '1086311',
                  'value': 'Легкоатлетический кросс',
                },
                {
                  'isn': '1073281',
                  'value': 'Метание ножей',
                },
                {
                  'isn': '866381',
                  'value': 'Мини-футбол',
                },
                {
                  'isn': '1027991',
                  'value': 'Морское многоборье',
                },
                {
                  'isn': '852691',
                  'value': 'Парусный спорт',
                },
                {
                  'isn': '852701',
                  'value': 'Пауэрлифтинг',
                },
                {
                  'isn': '852711',
                  'value': 'Пейнтбол',
                },
                {
                  'isn': '988251',
                  'value': 'Плавание подводное',
                },
                {
                  'isn': '984251',
                  'value': 'Полиатлон',
                },
                {
                  'isn': '852901',
                  'value': 'Силовое троеборье',
                },
                {
                  'isn': '1060371',
                  'value': 'Скиппинг',
                },
                {
                  'isn': '1029481',
                  'value': 'Современное пятиборье',
                },
                {
                  'isn': '957801',
                  'value': 'Современный мечевой бой',
                },
                {
                  'isn': '853061',
                  'value': 'Страйкбол',
                },
                {
                  'isn': '853071',
                  'value': 'Стрельба (все виды)',
                },
                {
                  'isn': '1029471',
                  'value': 'Стрельба из лука',
                },
                {
                  'isn': '853081',
                  'value': 'Стритбол ( уличный баскетбол)',
                },
                {
                  'isn': '853151',
                  'value': 'Триатлон',
                },
                {
                  'isn': '853171',
                  'value': 'Тяжелая атлетика',
                },
                {
                  'isn': '853211',
                  'value': 'Фигурное катание',
                },
                {
                  'isn': '853251',
                  'value': 'Футбол',
                },
                {
                  'isn': '853291',
                  'value': 'Чир спорт',
                },
                {
                  'isn': '853331',
                  'value': 'Яхтинг',
                },
                {
                  'isn': '826911',
                  'value': 'Категория 4',
                },
                {
                  'isn': '1084121',
                  'value': 'Абсолютно реальный бой',
                },
                {
                  'isn': '851841',
                  'value': 'Акробатика воздушная',
                },
                {
                  'isn': '851881',
                  'value': 'Американский футбол',
                },
                {
                  'isn': '955841',
                  'value': 'Армейский рукопашный бой',
                },
                {
                  'isn': '851891',
                  'value': 'Армреслинг',
                },
                {
                  'isn': '985511',
                  'value': 'Атлетика воздушная',
                },
                {
                  'isn': '851981',
                  'value': 'Бобслей',
                },
                {
                  'isn': '852001',
                  'value': 'Бодифлаинг (аэродиум)',
                },
                {
                  'isn': '852041',
                  'value': 'Борьба вольная',
                },
                {
                  'isn': '852051',
                  'value': 'Борьба греко-римская',
                },
                {
                  'isn': '852061',
                  'value': 'Борьба классическая',
                },
                {
                  'isn': '957791',
                  'value': 'Борьба на поясах',
                },
                {
                  'isn': '983821',
                  'value': 'Борьба спортивная',
                },
                {
                  'isn': '1086541',
                  'value': 'Боулдеринг',
                },
                {
                  'isn': '984501',
                  'value': 'Велосипедный мотокросс (ВМХ)',
                },
                {
                  'isn': '852141',
                  'value': 'Воднолыжный спорт',
                },
                {
                  'isn': '852161',
                  'value': 'Военно-прикладной спорт',
                },
                {
                  'isn': '1085921',
                  'value': 'Воздушно-спортивный эквилибр',
                },
                {
                  'isn': '983921',
                  'value': 'Гимнастика воздушная',
                },
                {
                  'isn': '852241',
                  'value': 'Горнолыжный спорт',
                },
                {
                  'isn': '852271',
                  'value': 'Грэпплинг',
                },
                {
                  'isn': '852341',
                  'value': 'Дзюдо',
                },
                {
                  'isn': '852381',
                  'value': 'Зорбинг ( спуск с горы в шаре)',
                },
                {
                  'isn': '1074231',
                  'value': 'Ледолазание',
                },
                {
                  'isn': '1043371',
                  'value': 'Лонгбординг',
                },
                {
                  'isn': '852601',
                  'value': 'Лыжное двоеборье',
                },
                {
                  'isn': '985761',
                  'value': 'Мас-реслинг',
                },
                {
                  'isn': '987301',
                  'value': 'Могул',
                },
                {
                  'isn': '985021',
                  'value': 'Панкратион',
                },
                {
                  'isn': '1055071',
                  'value': 'Параспартакиада',
                },
                {
                  'isn': '1074541',
                  'value': 'Пешее восхождение в горы',
                },
                {
                  'isn': '852751',
                  'value': 'Подводная охота',
                },
                {
                  'isn': '852761',
                  'value': 'Пожарно-прикладной спорт',
                },
                {
                  'isn': '852801',
                  'value': 'Прыжки на лыжах с трамплина',
                },
                {
                  'isn': '852811',
                  'value': 'Пятиборье',
                },
                {
                  'isn': '852831',
                  'value': 'Регби',
                },
                {
                  'isn': '852841',
                  'value': 'Роллерспорт',
                },
                {
                  'isn': '852851',
                  'value': 'Рукопашный бой',
                },
                {
                  'isn': '852871',
                  'value': 'Самбо',
                },
                {
                  'isn': '852881',
                  'value': 'Санный спорт ( все виды)',
                },
                {
                  'isn': '1054481',
                  'value': 'Северное многоборье',
                },
                {
                  'isn': '957441',
                  'value': 'Скейтбординг',
                },
                {
                  'isn': '852961',
                  'value': 'Слалом (лыжный)',
                },
                {
                  'isn': '852981',
                  'value': 'Снегоходный спорт',
                },
                {
                  'isn': '852991',
                  'value': 'Сноубординг',
                },
                {
                  'isn': '853041',
                  'value': 'Спортивные единоборства',
                },
                {
                  'isn': '1027331',
                  'value': 'Трейлраннинг',
                },
                {
                  'isn': '957421',
                  'value': 'Универсальный бой',
                },
                {
                  'isn': '993151',
                  'value': 'Флорбол',
                },
                {
                  'isn': '853241',
                  'value': 'Фристайл (лыжный)',
                },
                {
                  'isn': '853271',
                  'value': 'Хоккей ( все виды)',
                },
                {
                  'isn': '982791',
                  'value': 'Хоккей с мячом',
                },
                {
                  'isn': '982801',
                  'value': 'Хоккей с шайбой',
                },
                {
                  'isn': '982201',
                  'value': 'Цирковая студия',
                },
                {
                  'isn': '1081971',
                  'value': 'Экстремальный забег с препятствиями',
                },
                {
                  'isn': '826921',
                  'value': 'Категория 5',
                },
                {
                  'isn': '987311',
                  'value': 'Автомногоборье',
                },
                {
                  'isn': '851801',
                  'value': 'Автоспорт',
                },
                {
                  'isn': '851811',
                  'value': 'Айкидо',
                },
                {
                  'isn': '851831',
                  'value': 'Аквабайк',
                },
                {
                  'isn': '852021',
                  'value': 'Бокс',
                },
                {
                  'isn': '852121',
                  'value': 'Виндсерфинг',
                },
                {
                  'isn': '852151',
                  'value': 'Водно-моторный спорт',
                },
                {
                  'isn': '852171',
                  'value': 'Воздухоплавание (воздушный шар)',
                },
                {
                  'isn': '1041531',
                  'value': 'Восточные единоборства',
                },
                {
                  'isn': '852291',
                  'value': 'Дайвинг ( на глубину не свыше 30м.)',
                },
                {
                  'isn': '852311',
                  'value': 'Дельтапланеризм',
                },
                {
                  'isn': '852331',
                  'value': 'Джиу-джитсу',
                },
                {
                  'isn': '993551',
                  'value': 'Кёкусинкай',
                },
                {
                  'isn': '852411',
                  'value': 'Кайтинг',
                },
                {
                  'isn': '852421',
                  'value': 'Кайтсерфинг',
                },
                {
                  'isn': '852441',
                  'value': 'Карате',
                },
                {
                  'isn': '984771',
                  'value': 'Карате до',
                },
                {
                  'isn': '852451',
                  'value': 'Картинг',
                },
                {
                  'isn': '984781',
                  'value': 'Кикскутеринг',
                },
                {
                  'isn': '868131',
                  'value': 'Киокусинкай',
                },
                {
                  'isn': '1038911',
                  'value': 'Кунг-фу',
                },
                {
                  'isn': '985031',
                  'value': 'Мотокросс',
                },
                {
                  'isn': '852641',
                  'value': 'Мотоспорт',
                },
                {
                  'isn': '852651',
                  'value': 'Параглайдинг',
                },
                {
                  'isn': '852661',
                  'value': 'Парапланеризм',
                },
                {
                  'isn': '984511',
                  'value': 'Самбо боевое',
                },
                {
                  'isn': '1078481',
                  'value': 'Сапсерфинг',
                },
                {
                  'isn': '852891',
                  'value': 'Серфинг',
                },
                {
                  'isn': '1080981',
                  'value': 'Силовой экстрим',
                },
                {
                  'isn': '852971',
                  'value': 'Смешанные единоборства',
                },
                {
                  'isn': '853011',
                  'value': 'Спидвей',
                },
                {
                  'isn': '853091',
                  'value': 'Сумо',
                },
                {
                  'isn': '853161',
                  'value': 'Тхэквондо',
                },
                {
                  'isn': '853191',
                  'value': 'Ушу',
                },
                {
                  'isn': '1026541',
                  'value': 'Хапкидо',
                },
                {
                  'isn': '853321',
                  'value': 'Эндуро',
                },
                {
                  'isn': '826931',
                  'value': 'Категория 6',
                },
                {
                  'isn': '851871',
                  'value': 'Альпинизм',
                },
                {
                  'isn': '852011',
                  'value': 'Бои без правил',
                },
                {
                  'isn': '852031',
                  'value': 'Бокс тайский',
                },
                {
                  'isn': '852101',
                  'value': 'Вейкборд',
                },
                {
                  'isn': '852301',
                  'value': 'Дайвинг ( на грубину свыше 30м.)',
                },
                {
                  'isn': '852321',
                  'value': 'Джампинг (экстремальные прыжки)',
                },
                {
                  'isn': '852481',
                  'value': 'Каякинг',
                },
                {
                  'isn': '852501',
                  'value': 'Кикбоксинг',
                },
                {
                  'isn': '984291',
                  'value': 'Кобудо',
                },
                {
                  'isn': '852571',
                  'value': 'Кудо',
                },
                {
                  'isn': '852631',
                  'value': 'ММА',
                },
                {
                  'isn': '852621',
                  'value': 'Маунтинбайк',
                },
                {
                  'isn': '852671',
                  'value': 'Парашютный спорт',
                },
                {
                  'isn': '852681',
                  'value': 'Паркур',
                },
                {
                  'isn': '989061',
                  'value': 'Подводный спорт',
                },
                {
                  'isn': '852771',
                  'value': 'Полеты на летательном аппарате',
                },
                {
                  'isn': '1027341',
                  'value': 'Скайраннинг',
                },
                {
                  'isn': '852921',
                  'value': 'Скайсерфинг',
                },
                {
                  'isn': '852941',
                  'value': 'Скалолазание по природному рельефу',
                },
                {
                  'isn': '853001',
                  'value': 'Спелеотуризм',
                },
                {
                  'isn': '853021',
                  'value': 'Сплав ( все виды)',
                },
                {
                  'isn': '853181',
                  'value': 'Укадо',
                },
                {
                  'isn': '853231',
                  'value': 'Фри-дайвинг',
                },
              ],
            },
            {
              'isn': '261604813',
              'attrIsn': '949111',
              'fullName': 'Страховая сумма',
              'val': '100000',
              'value': '100000',
              'values': [
                '10000',
                20000,
                30000,
                40000,
                50000,
                60000,
                70000,
                80000,
                90000,
                100000,
                110000,
                120000,
                130000,
                140000,
                150000,
                160000,
                170000,
                180000,
                190000,
                200000,
                210000,
                220000,
                230000,
                240000,
                250000,
                260000,
                270000,
                280000,
                290000,
                300000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                380000,
                390000,
                400000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                470000,
                480000,
                490000,
                500000,
                510000,
                520000,
                530000,
                540000,
                550000,
                560000,
                570000,
                580000,
                590000,
                600000,
                610000,
                620000,
                630000,
                640000,
                650000,
                660000,
                670000,
                680000,
                690000,
                700000,
                710000,
                720000,
                730000,
                740000,
                750000,
                760000,
                770000,
                780000,
                790000,
                800000,
                810000,
                820000,
                830000,
                840000,
                850000,
                860000,
                870000,
                880000,
                890000,
                900000,
                910000,
                920000,
                930000,
                940000,
                950000,
                960000,
                970000,
                980000,
                990000,
                1000000,
              ],
            },
            {
              'isn': '261604808',
              'attrIsn': '949041',
              'fullName': 'Период действия защиты',
              'val': '949971',
              'value': 'На период занятия спортом',
              'values': [
                {
                  'isn': '949981',
                  'value': '24 часа в сутки',
                },
                {
                  'isn': '949971',
                  'value': 'На период занятия спортом',
                },
              ],
            },
            {
              'isn': '261604807',
              'attrIsn': '959211',
              'fullName': 'Кол-во застрахованных взрослых',
              'val': '1',
              'value': '1',
              'values': null,
            },
            {
              'isn': '261604812',
              'attrIsn': '959201',
              'fullName': 'Кол-во застрахованных детей',
              'val': '0',
              'value': '0',
              'values': null,
            },
          ],
        };
        this.store.externalData = data;
        this.store.externalData.params.forEach((el) => {
          this.mapApiAttributes.forEach((attr) => {
            if (attr.attrIsn === el.attrIsn) {
              this.store.dictionaries[attr.dictionary] = el.values;
            }
          });
        });
        this.store.currentRoute = 'step2';
        console.log('init');
        // end mock
      }
    },
  },
  mounted() {
    if (!this.mock) {
      this.$api.login(this.access.username, this.access.password)
          .then((data) => {
            this.token = data.token;
            this.init();
          })
    } else {
      this.init();
    }
  },
};
/* install
var script = document.createElement('script');
    script.src = 'http://localhost/js/app.8225f248.js'
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'http://localhost/css/app.a0196b76.css';
    document.body.appendChild(script);
    document.head.appendChild(css);
*/
</script>

<style>


#ns-asko {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.slide-leave-active,
.slide-enter-active {
  transition: .4s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}

input[type='number'] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

@media screen and (max-width: 480px) {
  .head[data-v-ce2d7ad6] {
    font-size: 1rem;
    font-weight: 600;
    color: #472483;
    text-align: center;
    margin-bottom: 40px;
  }
}
</style>

